import React from 'react';
import { Check } from 'lucide-react';

const ChatbotManagement = () => {
  return (
    <section className="py-16 sm:py-24 px-3 sm:px-4 bg-white overflow-hidden">
      <div className="max-w-6xl mx-auto">
        {/* Section Label */}
        <p className="text-[#25D366] font-medium mb-3 sm:mb-4 uppercase tracking-wide text-xs sm:text-sm text-center">Chatbot Management</p>
        
        <div className="grid md:grid-cols-2 gap-6 sm:gap-8 md:gap-12 items-center">
          {/* Content */}
          <div>
            <h2 className="text-xl sm:text-3xl md:text-5xl font-bold text-gray-900 mb-4 sm:mb-6">
              Manage all your chatbots in <span className="italic">just one place</span>
            </h2>
            <p className="text-gray-600 text-sm sm:text-lg leading-relaxed mb-6 sm:mb-8">
              Streamline your chatbot management with waatee. All your chatbots in one place,
              with a user-friendly interface, advanced reporting, and seamless integration with
              Telegram and WhatsApp.
            </p>
            
            <ul className="space-y-3 sm:space-y-4 mb-6 sm:mb-8">
              <li className="flex items-start gap-2 sm:gap-3">
                <div className="w-4 sm:w-5 h-4 sm:h-5 bg-blue-100 rounded-full flex items-center justify-center mt-0.5 flex-shrink-0">
                  <Check className="w-2.5 sm:w-3 h-2.5 sm:h-3 text-blue-500" />
                </div>
                <span className="text-gray-700 text-sm sm:text-base">User-friendly interface for all chatbot operations</span>
              </li>
              <li className="flex items-start gap-2 sm:gap-3">
                <div className="w-4 sm:w-5 h-4 sm:h-5 bg-blue-100 rounded-full flex items-center justify-center mt-0.5 flex-shrink-0">
                  <Check className="w-2.5 sm:w-3 h-2.5 sm:h-3 text-blue-500" />
                </div>
                <span className="text-gray-700 text-sm sm:text-base">Advanced reporting and analytics dashboard</span>
              </li>
              <li className="flex items-start gap-2 sm:gap-3">
                <div className="w-4 sm:w-5 h-4 sm:h-5 bg-blue-100 rounded-full flex items-center justify-center mt-0.5 flex-shrink-0">
                  <Check className="w-2.5 sm:w-3 h-2.5 sm:h-3 text-blue-500" />
                </div>
                <span className="text-gray-700 text-sm sm:text-base">Seamless Telegram and WhatsApp integration</span>
              </li>
            </ul>

            <a
              href="https://app.waatee.com/register"
              className="inline-flex items-center text-[#25D366] font-medium hover:text-[#1da851] transition-colors text-sm sm:text-base"
            >
              Get started →
            </a>
          </div>

          {/* Visual */}
          <div className="relative">
            <div className="bg-gradient-to-br from-blue-50 to-cyan-50 rounded-xl sm:rounded-2xl p-3 sm:p-6">
              <div className="bg-white rounded-lg sm:rounded-xl shadow-lg p-4 sm:p-6">
                <div className="flex items-center gap-2 sm:gap-3 mb-4 sm:mb-6">
                  <div className="w-8 sm:w-10 h-8 sm:h-10 bg-[#25D366] rounded-lg sm:rounded-xl flex items-center justify-center">
                    <svg viewBox="0 0 24 24" className="w-5 sm:w-6 h-5 sm:h-6 text-white" fill="currentColor">
                      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
                    </svg>
                  </div>
                  <span className="font-semibold text-gray-800 text-sm sm:text-base">Chatbot Manager</span>
                </div>
                <div className="space-y-2 sm:space-y-3">
                  <div className="flex items-center justify-between p-3 sm:p-4 bg-gray-50 rounded-lg sm:rounded-xl hover:bg-gray-100 transition-colors cursor-pointer">
                    <div className="flex items-center gap-2 sm:gap-3 min-w-0">
                      <div className="w-8 sm:w-10 h-8 sm:h-10 bg-blue-500 rounded-full flex items-center justify-center flex-shrink-0">
                        <span className="text-white text-xs sm:text-sm font-bold">T</span>
                      </div>
                      <div className="min-w-0">
                        <p className="font-medium text-gray-800 text-sm sm:text-base truncate">Telegram Bot</p>
                        <p className="text-xs sm:text-sm text-gray-500 truncate">Active • 1.2k users</p>
                      </div>
                    </div>
                    <div className="w-2.5 sm:w-3 h-2.5 sm:h-3 bg-green-400 rounded-full flex-shrink-0"></div>
                  </div>
                  <div className="flex items-center justify-between p-3 sm:p-4 bg-gray-50 rounded-lg sm:rounded-xl hover:bg-gray-100 transition-colors cursor-pointer">
                    <div className="flex items-center gap-2 sm:gap-3 min-w-0">
                      <div className="w-8 sm:w-10 h-8 sm:h-10 bg-[#25D366] rounded-full flex items-center justify-center flex-shrink-0">
                        <span className="text-white text-xs sm:text-sm font-bold">W</span>
                      </div>
                      <div className="min-w-0">
                        <p className="font-medium text-gray-800 text-sm sm:text-base truncate">WhatsApp Bot</p>
                        <p className="text-xs sm:text-sm text-gray-500 truncate">Active • 2.3k users</p>
                      </div>
                    </div>
                    <div className="w-2.5 sm:w-3 h-2.5 sm:h-3 bg-green-400 rounded-full flex-shrink-0"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ChatbotManagement;
